import { render, staticRenderFns } from "./ItemListPositionInput.vue?vue&type=template&id=6c2093f5&"
import script from "./ItemListPositionInput.vue?vue&type=script&lang=js&"
export * from "./ItemListPositionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2093f5')) {
      api.createRecord('6c2093f5', component.options)
    } else {
      api.reload('6c2093f5', component.options)
    }
    module.hot.accept("./ItemListPositionInput.vue?vue&type=template&id=6c2093f5&", function () {
      api.rerender('6c2093f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ItemListPositionInput.vue"
export default component.exports